import React from 'react';

/**
 * Full-page skeleton for self-service catalog pages (Education, Work Experience,
 * Certificates), which all share the same layout: a title block, a row of four
 * statistics cards, a filter bar, an action button and a two-column grid of
 * record cards.
 *
 * Do not use this on master–detail worklists (Work Pass, Termination).
 * Those already paint header + tabs and must use
 * SelfServiceWorklistSkeleton so the pulse matches the inbox + reader.
 *
 * Per the DS loading standard: full page navigation / initial load => skeleton.
 */
const SelfServiceListSkeleton = () => {
  return (
    <div className="max-w-7xl mx-auto">
      {/* Title */}
      <div className="mb-8 space-y-2 animate-pulse">
        <div className="h-9 bg-gray-200 rounded w-64"></div>
        <div className="h-5 bg-gray-200 rounded w-96 max-w-full"></div>
      </div>

      {/* Statistics Cards */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-6 mb-6 sm:mb-8">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="bg-white rounded-lg shadow-md p-6 animate-pulse">
            <div className="flex items-center">
              <div className="w-12 h-12 bg-gray-200 rounded-full flex-shrink-0"></div>
              <div className="ml-4 space-y-2 min-w-0">
                <div className="h-4 bg-gray-200 rounded w-24"></div>
                <div className="h-7 bg-gray-200 rounded w-16"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Filter bar */}
      <div className="mb-6">
        <div className="h-12 bg-gray-200 rounded-lg w-full animate-pulse"></div>
      </div>

      {/* Action button */}
      <div className="flex justify-between items-center mb-6">
        <div className="h-10 bg-gray-200 rounded-lg w-36 animate-pulse"></div>
      </div>

      {/* Record cards grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="bg-white rounded-lg shadow-md p-6 animate-pulse">
            <div className="space-y-3">
              <div className="h-5 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              <div className="h-4 bg-gray-200 rounded w-2/3"></div>
              <div className="flex gap-2 pt-2">
                <div className="h-6 bg-gray-200 rounded-full w-20"></div>
                <div className="h-6 bg-gray-200 rounded-full w-24"></div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelfServiceListSkeleton;
